module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/recommend_1_02-a04ad432235c309f6a690b6260cd8313.jpg";